<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <!-- <img class="img-responsive" src="@/assets/img/front.jpg" alt="front" style="width:100%;height:80px"> -->
      <el-image style="width:100%; height:60px" :src="require('@/assets/img/front.png')" fit="fill"></el-image>
    </div>


    <!-- 电脑导航 -->
    <div class="header-nav navbar-fixed-top container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="goHome">
        <img src="@/assets/img/logo2.png">
      </div>
      <!-- 导航内容 -->
      <!--jet1228 初始判断条件[index==navIndex],为保证首页跳转路由正常显示加入优化【item.path == currentPath || (index==navIndex && index!=0)】 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="item.path == currentPath || (index==navIndex && index!=0) ? 'active' : ''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <!-- jet1231测试不使用二级单独页，单独使用参数params,测试异常待解决 -->
              <!-- <router-link :to="{path:i.path, params:i.params}">{{i.name}}</router-link> -->
              <!-- <router-link  :to="i.path+'/'+i.params.index" >{{i.name}}</router-link> -->
              <router-link :to="i.path" >{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo"  @click="goHome">
        <img class="center-block" src="@/assets/img/logo2.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <!--jet1228 初始判断条件[index==navIndex],为保证首页跳转路由正常显示加入优化【item.path == currentPath || (index==navIndex && index!=0)】 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="item.path == currentPath || (index==navIndex && index!=0) ? 'active' : ''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Header",
  data() {
    return {
      currentPath: '', //jet1228当前页面路径
    
      config: config,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/home",
          children: []
        },
        {
          name: "杰出集团",
          path: "/aboutgroup",
          children: []
        },

        {
          name: "集团业务",
          path: "/groupbusiness",
          children: []
        },

        {
          name: "杰出资讯",
          path: "/groupnews",
          children: []
        },
        {
          name: "党群建设",
          path: "/partybuilding",
          children: []
        },
        {
          name: "智慧引才",
          path: "/wisdomtalents",
          children: []
        },
       
        {
          name: "行业研究",
          path: "/industryresearch",
          children: []
        },

        {
          name: "遇见杰出",
          path: "/meetjiechu",
          children: []
        },

        // {
        //   name: "软件产品(备用)",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "Tessai资管后台系统",
        //       path: "/software/smartTown",
        //       params:{
        //         index: 3,
        //       }
        //     },
        //     {
        //       name: "Tessai客户端系统",
        //       path: "/software/bigData",
        //       params:{
        //         index: 3,
        //       }
        //     },
        //     {
        //       name: "集团业务测试",
        //       path: "/groupbusiness",
        //       params:{
        //         index: 3,
        //       },
        //     },
        //   ]
        // },
      ]
    };
  },

  //jet1228 监听属性，实时监听页面路由
  watch: {
	  $route:{
		  handler: function(route){
			  console.log('header 页面路由=>',route)
        this.currentPath = route.path; //注意：route.path  == this.$route.path
			  console.log('header页 data currentPath=>', this.currentPath)

        //获取当前路由名称
        const currentPathObj = this.navList.find(e=>e.path === route.path)
        this.menuName = currentPathObj.name ? currentPathObj.name : '杰出集团';
        console.log('当前菜单=>',currentPathObj,'当前菜单名=>',this.menuName)
		  },
		  immediate: true,
	  }
  },


  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },

    //logo点击跳转首页
    goHome(){
      this.$router.push({
        name: 'home',
        params: {}
      })
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #F8FAFB;
  transition: all ease 0.6s;
}

/*jet1228 header高度设置媒体查询 */
/* 小于1080 */
@media screen and (min-width: 600px) and (max-width:3840px){
  #header{
    height: 110px !important;
  } 
}

#header .header-top {
  height: 50px;
  color: #F8FAFB;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #DDE2E6;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 184px;
  height: 100%;
  float: left;
  position: relative;
  /* margin-left: 200px; */

  /* margin-left: 150px; */
  margin-left: 4vw;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 184px;
  height: 64px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
  
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  margin: 0;
  /* float: left;
  max-width: 1600px;
  margin-left: 200px; */

  /* float: right;
  max-width: 1600px;
  margin-right: 100px; */

  /* float: left;
  max-width: 1600px;
  margin-left: 100px; */

  float: right;
  max-width: 1600px;
  margin-right: 3vw;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  position: relative; 
  /* margin: 0 30px; */

  margin: 0 20px;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #414141;
  font-size: 22px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1471DB;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1471DB;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1471DB;
  text-decoration: none;
  border-bottom: 2px solid #1471DB;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #F8FAFB;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
    background-color: #fff;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #F8FAFB;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #1471DB;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #F8FAFB;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #1471DB;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #F8FAFB;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
    text-decoration: none;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue